export default "__VITE_ASSET__508fd8e2__"